/* AEC category pills: filter the home product grid in place. See sections/aec-category-pills.liquid. */
(() => {
  const root = document.querySelector('[data-aec-pills]');
  const grid = document.querySelector('#MainContent .collection .product-grid');
  if (!root || !grid) return;

  const section = grid.closest('.collection') || grid.parentElement;
  const pillsSection = root.closest('.shopify-section') || root;
  const viewAllOriginal = section.querySelector('.collection__view-all');
  const pills = [...root.querySelectorAll('.aec-pill')];
  const handles = new Set(pills.map((p) => p.dataset.handle));
  const cache = new Map();
  let current = '';
  let token = 0;

  grid.setAttribute('data-aec-pills-grid', '');
  cache.set('', { html: grid.innerHTML, count: 0 });

  const more = document.createElement('div');
  more.className = 'aec-viewall-wrap';
  more.hidden = true;
  more.innerHTML = '<a class="aec-viewall" href="#"></a>';
  grid.after(more);

  const headerHeight = () => {
    const h = document.querySelector('.section-header');
    return h ? h.getBoundingClientRect().height : 0;
  };
  const setHeaderVar = () => document.documentElement.style.setProperty('--aec-header-h', headerHeight() + 'px');
  setHeaderVar();
  window.addEventListener('resize', setHeaderVar);

  const settle = () => {
    // Swapped-in markup must not wait for Rise's scroll-reveal observer.
    grid.querySelectorAll('.scroll-trigger').forEach((el) => el.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--slide-in'));
  };

  const keepPosition = () => {
    const stuck = pillsSection.getBoundingClientRect().top <= headerHeight() + 1 && window.scrollY > 0;
    if (!stuck) return;
    const y = grid.getBoundingClientRect().top + window.scrollY - headerHeight() - pillsSection.getBoundingClientRect().height - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
  };

  const markPressed = (handle) => pills.forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.handle === handle)));

  const render = (handle, entry) => {
    grid.classList.add('aec-fading');
    setTimeout(() => {
      grid.innerHTML = entry.html;
      settle();
      const shown = grid.querySelectorAll(':scope > .grid__item').length;
      if (viewAllOriginal) viewAllOriginal.hidden = handle !== '';
      if (handle && entry.count > shown) {
        const a = more.querySelector('a');
        a.href = entry.url;
        a.textContent = 'View all ' + entry.label + ' →';
        more.hidden = false;
      } else {
        more.hidden = true;
      }
      grid.classList.remove('aec-loading');
      keepPosition();
      requestAnimationFrame(() => grid.classList.remove('aec-fading'));
    }, 200);
  };

  const apply = async (handle) => {
    if (!handles.has(handle)) handle = '';
    if (handle === current) return;
    current = handle;
    markPressed(handle);
    const mine = ++token;
    let entry = cache.get(handle);
    if (!entry) {
      grid.classList.add('aec-loading');
      try {
        const res = await fetch('/collections/' + encodeURIComponent(handle) + '?section_id=aec-pill-grid', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const list = doc.querySelector('[data-aec-pill-grid]');
        if (!list) throw new Error('no grid');
        const pill = pills.find((p) => p.dataset.handle === handle);
        entry = {
          html: list.innerHTML,
          count: Number(list.dataset.count || 0),
          url: list.dataset.url || '/collections/' + handle,
          label: (pill && pill.dataset.label) || list.dataset.title || '',
        };
        cache.set(handle, entry);
      } catch (e) {
        window.location.href = '/collections/' + encodeURIComponent(handle);
        return;
      }
    }
    if (mine !== token) return;
    render(handle, entry);
  };

  const hashHandle = () => decodeURIComponent((window.location.hash || '').replace(/^#/, ''));

  root.addEventListener('click', (e) => {
    const pill = e.target.closest('.aec-pill');
    if (!pill) return;
    const handle = pill.dataset.handle;
    if (handle === current) return;
    const url = handle ? '#' + handle : window.location.pathname + window.location.search;
    history.pushState(null, '', url);
    apply(handle);
  });

  window.addEventListener('popstate', () => apply(hashHandle()));

  const initial = hashHandle();
  if (initial && handles.has(initial)) apply(initial);
})();
